/* eslint-disable */
import React from 'react';
import { Box, Chip } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';

const DevelopmentTag = () => {
    const buildMode = process.env.REACT_APP_BUILD_MODE;
    
    // Only show in development mode
    if (buildMode === 'production') {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: { xs: '2px', sm: '10px' },
                left: { xs: 'auto', sm: '10px' },
                right: { xs: '2px', sm: 'auto' },
                zIndex: 9999,
                pointerEvents: 'none',
                opacity: { xs: 0.8, sm: 1 },
                transform: { xs: 'scale(0.8)', sm: 'scale(1)' },
                transformOrigin: { xs: 'top right', sm: 'top left' }
            }}
        >
            <Chip
                icon={<BugReportIcon />}
                label={buildMode.toUpperCase() + " MODE"}
                color="error"
                size="medium"
                sx={{
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#d32f2f',
                    color: 'white',
                    '& .MuiChip-icon': {
                        fontSize: '1.25rem',
                        color: 'white'
                    },
                    '&:hover': {
                        backgroundColor: '#b71c1c'
                    }
                }}
            />
        </Box>
    );
};

export default DevelopmentTag; 